import React from "react";
import ReactDOM from "react-dom";
import Button from "./button.js";
import Heading from "./heading.js";
import { _ } from "../utils/i18n.js";

const MiniShare = ({ onClose, cartLink }) => {
  const copyToClipboard = async () => {
    await navigator.clipboard.writeText(cartLink);
    alert(_("Handlevognlenke kopiert til utklippstavlen!"));
  };

  return ReactDOM.createPortal(
    <div
      className="popup-overlay"
      role="dialog"
      aria-modal="true"
      aria-labelledby="minishare-title"
    >
      <div className="popup-content">
        <button className="close" onClick={onClose} aria-label={_("Lukk")}>
          &times;
        </button>
        <Heading
          level={2}
          textAlign="center"
          content={_("Del handlekurven din")}
        />
        <input style={{ height: 48 }} type="text" readOnly value={cartLink} />
        <Button
          onClick={copyToClipboard}
          variant="filled"
          style={{
            width: "100%",
          }}
        >
          {_("Kopiere lenken til utklippstavle")}
        </Button>
      </div>
    </div>,
    document.body
  );
};

export default MiniShare;
